import { useDispatch, useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import './index.css';
import {
  getConversationsList,
  setLocation
} from '../../../redux/slices/communication';

import Symbol from '../../utils/symbol';
import {
  FACEBOOK,
  GOOGLE,
  INSTAGRAM,
  LINKEDIN_PERSONAL_ACCOUNT,
  TIKTOK_BUSINESS_PAGE,
  TWITTER,
  YOUTUBE
} from '../../../config/constants';
import { PLATFORM_STATIC_ICONS_PNG } from '../../../config/icons';
import toast from 'react-hot-toast';
import { useTranslate } from '@tolgee/react';

export const LocationCard = ({ location }) => {
  const {
    data: { locations: selectedLocations }
  } = useSelector((state) => state.communication);
  const icons = {
    [FACEBOOK]: location.is_facebook_linked,
    [INSTAGRAM]: location.is_instagram_linked,
    [GOOGLE]: location.is_google_linked,
    [TWITTER]: location.is_twitter_linked,
    [LINKEDIN_PERSONAL_ACCOUNT]: location.is_linkedin_personal_account_linked,
    [LINKEDIN_PERSONAL_ACCOUNT]: location.is_linkedin_business_page_linked,
    [YOUTUBE]: location.is_youtube_linked,
    [TIKTOK_BUSINESS_PAGE]: location.is_tiktok_business_page_linked
  };
  const MAX_SELECTED_LOCATIONS = 20;
  const iconsToRender = Object.keys(icons)
    .filter((key) => icons[key])
    .map((key) => PLATFORM_STATIC_ICONS_PNG[key]);
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const selectLocation = () => {
    const locationsUuids = selectedLocations.map((location) => location.uuid);
    if (
      locationsUuids.length >= MAX_SELECTED_LOCATIONS &&
      !locationsUuids.includes(location.uuid)
    ) {
      toast.error(t('communication.toast.max_select_20_locations'), {
        position: 'top-right',
        id: 'select-location'
      });
    } else {
      dispatch(setLocation(location));
      dispatch(getConversationsList());
    }
  };
  return (
    <div
      className={`card p-3 w-100 shadow-xs cursor-pointer  user-select-none ${
        selectedLocations
          .map((location) => location.uuid)
          .includes(location.uuid)
          ? 'border border-primary'
          : ''
      }`}
      onClick={selectLocation}
    >
      <div className="d-flex align-items-center">
        {location.image ? (
          <img src={location.image} className="w-50px h-50px rounded" />
        ) : (
          <Symbol initials={location.initials} />
        )}

        <div className="p-2">
          <h5 className="m-0 p-0 user-select-none">{location.name}</h5>
          <div>
            {iconsToRender.map((icon) => (
              <img
                src={icon}
                className="w-15px h-15px"
                style={{ marginRight: 2 }}
                key={icon}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
LocationCard.propTypes = {
  location: PropTypes.object.isRequired
};
